import React from "react";
import { Box, Typography, Fade, alpha } from "@mui/material";
import { SwapHoriz as SwapIcon } from "@mui/icons-material";

import { calculateDuration } from "./utils";

const DurationPreview = ({
    startDate,
    endDate,
    theme,
    isArabic,
}) => {
    const duration = calculateDuration(
        startDate,
        endDate
    );

    if (!startDate || !endDate) return null;

    return (
        <Fade in>
            <Box
                sx={{
                    mt: 1.5,
                    p: 1.2,
                    borderRadius: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,

                    bgcolor: alpha(
                        theme.palette.success.main,
                        0.08
                    ),
                    border: `1px solid ${alpha(
                        theme.palette.success.main,
                        0.25
                    )}`,
                }}
            >
                <SwapIcon
                    sx={{
                        color: "success.main",
                        fontSize: 20,
                    }}
                />

                <Typography
                    variant="caption"
                    fontWeight={700}
                    color="success.main"
                >
                    {duration.days}{" "}
                    {isArabic ? "يوم" : "Day"}
                    {duration.days > 1 &&
                        !isArabic &&
                        "s"}

                    {duration.nights > 0 && (
                        <>
                            {" "}•{" "}
                            {duration.nights}{" "}
                            {isArabic
                                ? duration.nights === 1
                                    ? "ليلة"
                                    : "ليالي"
                                : duration.nights === 1
                                    ? "Night"
                                    : "Nights"}
                        </>
                    )}
                </Typography>
            </Box>
        </Fade>
    );
};

export default DurationPreview;